import React from 'react'
import { Button } from 'react-bootstrap'
import { Plus } from 'react-bootstrap-icons'
import EditForm from '../edit-form'

const NewItem = () => {
    const [ formVisible, setFormVisible ] = React.useState()
    if (formVisible) {
        return (
            <EditForm onClose={() => setFormVisible(false)} />
        )
    }
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-end',
                alignItems: 'center'
            }}
        >
            <Button size="sm" onClick={() => setFormVisible(true)}><Plus/></Button>
        </div>
    )
}

export default NewItem